import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixSummaryHeaderProps } from "../types";

const currency = (value: number) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/**
 * Cabeçalho consolidado do modal de Pix (SP-1294 / D5):
 * valor total do pedido e contador "X de Y pagos".
 */
const PixSummaryHeader: React.FC<PixSummaryHeaderProps> = ({
  total,
  paidCount,
  count,
}) => {
  const classes = usePixModalStyles();
  const allPaid = count > 0 && paidCount === count;

  return (
    <div className={classes.summaryHeader}>
      <div className={classes.summaryTotal}>
        Total do pedido{" "}
        <span className={classes.summaryTotalValue}>{currency(total)}</span>
      </div>

      <span
        className={`${classes.summaryCounter} ${
          allPaid ? classes.summaryCounterAllPaid : ""
        }`}
      >
        {paidCount} de {count} pagos
      </span>
    </div>
  );
};

export default PixSummaryHeader;
